import { ReactComponent as StopBarricadeImage } from 'components/assets/stop-barricade.svg';
import BasePageWithTopNav from 'components/layout/TopNavigationLayout';
import ErrorCover from 'components/widgets/Error/Cover';

const SomethingWentWrong = () => {
  return (
    <BasePageWithTopNav>
      <ErrorCover
        errorImage={<StopBarricadeImage />}
        title="Something went wrong"
        subtitle="This shouldn’t happen, but sometimes it does"
        description="Sorry for the inconvenience. Our development team is working hard to get our systems back up and running as soon as possible."
      />
    </BasePageWithTopNav>
  );
};

export default SomethingWentWrong;
